import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ETjansterModule } from '@vinnova/e-tjanster';
import { environment } from '../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [ETjansterModule, RouterOutlet],
})
export class LayoutComponent implements OnInit {
  isProduction!: boolean;
  hasError = false;

  ngOnInit() {
    this.isProduction = environment.production;
  }
}
